/**
 * Created by daniel on 17/04/17.
 *
 * Component acts as a host for TableItems or BlockItems
 *
 * Can only be placed inside TableItems
 *
 * Generally I don't screw with the styles on these. Only alignment needs dealing with.
 *
 */

import React, {Component} from 'react';
import StyleItem from "./StyleItem";
import DropZone from "../ui/DropZone";
import * as _ from "lodash/object";

class RowItem extends Component {
  render() {
    return (
      <tr
        id={this.props.contentId}
        className={[this.props.contentId, this.props.viewClass,].join(" ").trim()}
        ref={(node) => {
          _.toPairs(this.props.viewAttributes).map((item) => {
            return node && node.setAttribute(item[0], item[1]);
          });
        }}
        {...this.props.eventHandlers}
        style={{
          width: this.props.styleWidth,
          height: this.props.styleHeight,
          padding: this.props.stylePadding,
          backgroundColor: this.props.styleBackgroundColour,
          color: this.props.styleTextColour,
          textAlign: this.props.styleTextAlignment,
        }}
      >
        <StyleItem selectorPrefix={this.props.contentId + " "} styleObject={this.props.viewCss}/>
        {
          this.props.children.length > 0 ? this.props.children :<td><DropZone text={this.props.configName}/></td>
        }
      </tr>
    );
  }
}

export default RowItem;


// WEBPACK FOOTER //
// ./src/App/Editor/components/primitives/RowItem.js